const translations = {
	title: "Transmettre le dossier",
	description:
		"Indiquez la personne qui signe le contrat pour la société de gestion. Elle reçoit le dossier et une demande de signature électronique. Sa signature valide le dossier.",
	replace: "La demande en cours, adressée à {{name}}, sera annulée et remplacée par celle-ci.",
	first_name: "Prénom",
	last_name: "Nom",
	email: "Adresse e-mail",
	email_caption: "Elle y reçoit le dossier et la demande de signature.",
	phone: "Téléphone portable",
	phone_caption: "Le code de signature y est envoyé par SMS.",
	submit: "Transmettre le dossier",
};

export default translations;
